module.exports = "/_next/static/images/detective-chat-avatar-b7d03fe6a85f3ec75986632efec9bdc2.jpg";